import React, { createContext, useContext } from 'react';
import useNavigationItemsWithActive from "../hooks/use-navigation-items-with-active.js";

const MobileNavigationContext = createContext({});

export const MobileNavigationContextProvider = ({ children, currentShopId, currentPage }) => {

    const activeNavigationItems = useNavigationItemsWithActive(currentShopId, currentPage);


    if(activeNavigationItems.isLoading || activeNavigationItems.isError ||!activeNavigationItems.data) {
        return null;
    }

    return (
        <MobileNavigationContext.Provider value={activeNavigationItems.data}>
            {children}
        </MobileNavigationContext.Provider>
    );
};

export const useMobileNavigationContext = () => {
    return useContext(MobileNavigationContext);
};